import { render, staticRenderFns } from "./OnBehalfPopup.vue?vue&type=template&id=c6092126&"
import script from "./OnBehalfPopup.vue?vue&type=script&lang=js&"
export * from "./OnBehalfPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports